import * as React from 'react';
import { Link } from 'react-router-dom';

import Button from '@/components/elements/Button/BaseButton';
import ModalBase, { ModalBasicProps } from '@/components/layouts/Modal/Base';
import { getLoginUrl } from '@/lib/dmm/accounts';
import { isCrawler } from '@/lib/userAgent';
import { defaultTheme } from '@/utility/theme';

import { ButtonLink, Container, SpBr, Wrapper } from './style';

interface GuestModalProps extends ModalBasicProps {}

const GuestModal: React.FC<GuestModalProps> = ({ isOpen, handleClose }) => {
  if (isCrawler) return <></>;

  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={() => handleClose()}
      desktopWidth="840px"
      backgroundColor={defaultTheme.background.white}
    >
      <Container>
        <Wrapper>
          <h2>
            投票するには
            <SpBr />
            DMM競輪へのログインが必要です
          </h2>
          <ButtonLink href={getLoginUrl()}>
            <Button size="m" bgColor="primary" radius="l" fontWeight="bold">
              ログイン
            </Button>
          </ButtonLink>
          <p>
            アカウントをお持ちで無い場合は
            <SpBr />
            <Link to="/signup">会員登録（無料）</Link>をしてください。
          </p>
        </Wrapper>
        <Wrapper>
          <h2>まずは登録不要でDMM競輪をお試し！</h2>
          <Button
            size="m"
            bgColor="primary"
            radius="l"
            fontWeight="bold"
            outline
            onClick={handleClose}
          >
            そのまま投票画面へ進む
          </Button>
          <p>
            ※実際に投票するには<Link to="/signup">会員登録</Link>もしくは
            <a href={getLoginUrl()}>ログイン</a>が必要です。
          </p>
        </Wrapper>
      </Container>
    </ModalBase>
  );
};

export default GuestModal;
